"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgFlash = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 15.05V21c0 .98 1.265 1.375 1.823.569l7-10.125a1 1 0 0 0-.604-1.545l-4.093-.92.864-5.832c.15-1.014-1.14-1.57-1.774-.767l-8 10.125a1 1 0 0 0 .564 1.596l4.22.949Zm2.011-5.447a1 1 0 0 0 .77 1.123l3.554.8L12 17.794V14.25a1 1 0 0 0-.78-.976l-3.45-.776 4.692-5.938-.45 3.043Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgFlash);
//# sourceMappingURL=SvgFlash.js.map